export default __webpack_public_path__ + "static/home-bg-1-fd076aa83427f5f02f8218957bf945be.png";